

















































import { View } from 'client-website-ts-library/plugins';
import { Config } from 'client-website-ts-library/services';
import { Context } from 'client-website-ts-library/types';
import { ContextItemType } from 'client-website-ts-library/types/Context';
import { Component, Mixins } from 'vue-property-decorator';

import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Form,
  },
})
export default class TransitionToCPOManagement extends Mixins(View) {
  private formData: Context | null = null;

  mounted() {
    this.formData = {
      Items: [
        {
          Type: ContextItemType.EnquiryTargetProfile,
          Id: '109843d2-21f8-49de-891c-3eab8871123d',
        },
      ],
      ClientWebsiteId: Config.Website.Id,
      WebsiteId: Config.Website.Settings!.WebsiteId,
      WebsiteLevel: Config.Website.Settings!.WebsiteLevel,
    };
  }
}
